<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-05-13 10:07:22
 * @LastEditTime : 2025-06-23 13:48:54
 * @LastEditors  : yangxr
 * @Description  : 对接表格组件
 * @FilePath     : \icps_fb\src\views\platform\ICPS\Wise\docking\incomeSheet\tableMain.vue
-->
<template>
    <div>
        <!-- <div class="card_nav">
            <div></div>
            <div>
                <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 20px">
                    <el-link :underline="false">
                        <span class="el-icon--left">
                            <i class="iconfont iconicon_button_filtrate"></i>
                        </span>
                        筛选
                    </el-link>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(item, index) in table" :key="index">
                            <el-checkbox v-model="item.status" @change="changeTable">{{ item.label }}</el-checkbox>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div> -->
        <div class="card_info">
            <!-- <el-table :id="isImg ? 'imgTable' : 'table'" :key="tableKey" :header-cell-style="{ background: '#f3f6f9' }"
                :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :height="height > 0 ? height : ''"
                :data="tableData" tooltip-effect="dark" :span-method="objectSpanMethod" show-summary
                :summary-method="getSummaries">
                <template v-for="(item, index) in table">
                    <el-table-column v-if="item.children" :key="`children-${index}`" :label="item.label" align="center"
                        :width="item.width" :prop="item.prop" :show-overflow-tooltip="true">
                        <template v-for="(item2, index2) in item.children">
                            <el-table-column v-if="item2" :key="index2" :label="item2.label" align="center"
                                :width="item2.width" :prop="item2.prop">
                                <template slot-scope="scope">
                                    <span>{{ scope.row[item2.prop] }}</span>
                                </template>
                            </el-table-column>
                        </template>
                    </el-table-column>
                    <el-table-column v-else :key="`no-children-${index}`" :label="item.label" align="center"
                        :width="item.width" :min-width="item.label == '工程名称' ? '200' : ''" :prop="item.prop"
                        :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span>{{ scope.row[item.prop] }}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table> -->
            <vxe-table :id="isImg ? 'imgTable' : 'table'" ref="rawTable" border align="center" header-align="center" show-overflow size="mini" 
            :height="height" :loading="tableLoading" :virtual-y-config="{enabled: true, gt: 0}" :virtual-x-config="{enabled: true, gt: 0}" :span-method="objectSpanMethod" :footer-method="getSummaries"
   :show-footer="true"         
                :data="tableData">
                <template v-for="(item, index) in table">
                    <vxe-column v-if="item.children" :key="`children-${index}`" :title="item.label" align="center"
                        :width="item.width" :field="item.prop" :show-overflow-tooltip="true">
                        <template v-for="(item2, index2) in item.children">
                            <vxe-column v-if="item2" :key="index2" :title="item2.label" align="center"
                                :width="item2.width" :field="item2.prop">
                                <template #default="{ row }">
                                    <span>{{ formatNumber(row[item2.prop]) }}</span>
                                </template>
                            </vxe-column>
                        </template>
                    </vxe-column>
                    <vxe-column v-else :key="`no-children-${index}`" :title="item.label" align="center"
                        :width="item.width" :min-width="item.label == '工程名称' ? '200' : ''" :field="item.prop"
                        :show-overflow-tooltip="true">
                        <template #default="{ row }">
                            <span>{{ formatNumber(row[item.prop]) }}</span>
                        </template>
                    </vxe-column>
                </template>
            </vxe-table>
        </div>
    </div>
</template>
  
<script>
export default {
    name: "tableMain",
    props: {
        tableData: {
            type: Array,
            default: () => [],
        },
        tableHead: {
            type: Array,
            default: () => [],
        },
        height: {
            type: String,
            default: "",
        },
        isImg: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            table: [
                { label: "工程id", prop: "engineeringId", status: true, width: "200" },
                { label: "工程名称", prop: "engineeringName", status: true, width: "auto" },
                { label: "共享客商编码", prop: "shareClientCode", status: true, width: "200" },
                { label: "共享合同编码", prop: "shareContractCode", status: true, width: "200" },
                { label: "共享项目编码", prop: "shareProjectCode", status: true, width: "200" },
                { label: "共享明细客户编号", prop: "shareDetailClientCode", status: true, width: "200" },
                { label: "共享明细客户", prop: "shareDetailClientName", status: true, width: "200" },
                { label: "计价项", prop: "productName", status: true, width: "200" },
                { label: "数量", prop: "quantityAll", status: true, width: "100" },
                { label: "合计", prop: "taxInclusiveAmountAll", status: true, width: "100" },

            ],
            tableKey: 0,
            tableLoading: false,
            needMergeArr: [
                "engineeringId",
                "engineeringName",
                "shareClientCode",
                "shareContractCode",
                "shareProjectCode",
                "shareDetailClientCode",
                "shareDetailClientName",
            ],
            rowMergeArrs: [],
        };
    },
    watch: {
        tableData(val) {
            this.rowMergeArrs = this.rowMergeHandle(this.needMergeArr, val);
        },
        tableHead(val) {
            console.log('-----------table-------------')
            console.log(val)
            this.table = this.$options.data().table
            this.table.splice(8, 0, ...val);
            this.tableKey = Math.random()
        },
    },
    methods: {
        formatNumber(value) {
      if (typeof value === 'number') {
        if (Math.abs(value) < 1e-8) {
          return '0';
        }
        return parseFloat(value.toFixed(8)).toString();
      }
      return value;
    },
    // getSummaries(param) {
    //         const { columns, data } = param;
    //         const sums = [];
    //         columns.forEach((column, index) => {
    //             if (index === 0) {
    //                 sums[index] = '合计';
    //                 return;
    //             } else if (index == 1 && index == 2 && index == 3 && index == 4) {
    //                 sums[index] = '';
    //                 return
    //             }

    //             const values = data.map(item => Number(item[column.property]));
    //             if (!values.every(value => isNaN(value))) {
    //                 sums[index] = values.reduce((prev, curr) => {
    //                     const value = Number(curr);
    //                     if (!isNaN(value)) {
    //                         return (Number(prev) + Number(curr)).toFixed(3);
    //                     } else {
    //                         return prev;
    //                     }
    //                 }, 0);
    //             } else {
    //                 sums[index] = '';
    //             }
    //         });

    //         return sums;
    //     },
    getSummaries ({ columns, data }) {
        let  sums = '';
              return [
                columns.map((column, columnIndex) => {
                  if (columnIndex === 0) {
                    return '合计'
                  }  else if (columnIndex == 1 && columnIndex == 2 && columnIndex == 3 && columnIndex == 4) {
                    return null
                }
                const values = data.map(item => Number(item[column.field]));
                if (!values.every(value => isNaN(value))) {
                    sums = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return (Number(prev) + Number(curr)).toFixed(3);
                        } else {
                            return prev;
                        }
                    }, 0);
                } else {
                    sums = '';
                }
                return sums
                })
              ]
            },
        // getSummaries(param) {
        //     const { columns, data } = param;
        //     let  sums = '';
        //     columns.forEach((column, index) => {
        //         if (index === 0) {
        //             sums = '合计';
        //             return sums;
        //         } else if (index == 1 && index == 2 && index == 3 && index == 4) {
        //             sums = '';
        //             return sums
        //         }

        //         const values = data.map(item => Number(item[column.property]));
        //         if (!values.every(value => isNaN(value))) {
        //             sums = values.reduce((prev, curr) => {
        //                 const value = Number(curr);
        //                 if (!isNaN(value)) {
        //                     return (Number(prev) + Number(curr)).toFixed(3);
        //                 } else {
        //                     return prev;
        //                 }
        //             }, 0);
        //         } else {
        //             sums = '';
        //         }
        //     });

        //     return sums;
        // },
        objectSpanMethod({ column, rowIndex, columnIndex }) {
            for (let res in this.needMergeArr) {
                if (this.needMergeArr[res] == column.property) {
                    return this.mergeAction(column.property, rowIndex, columnIndex);
                }
            }
        },
        mergeAction(val, rowIndex) {
            let _row = this.rowMergeArrs[val]['rowArr'][rowIndex];
            let _col = _row > 0 ? 1 : 0;
            return {rowspan:_row, colspan:_col};
        },
        rowMergeHandle(arr, data) {
            if (!Array.isArray(arr) && !arr.length) return false;
            if (!Array.isArray(data) && !data.length) return false;
            let needMerge = {};
            arr.forEach((i, idx) => {
                needMerge[i] = {
                    rowArr: [],
                    rowMergeNum: 0,
                };

                if (idx == 0) {
                    data.forEach((item, index) => {
                        // 表格首个数据单独处理
                        if (index === 0) {
                            needMerge[i].rowArr.push(1);
                            needMerge[i].rowMergeNum = 0;
                        } else {
                            if (item[i] === data[index - 1][i]) {
                                needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
                                needMerge[i].rowArr.push(0);
                            } else {
                                needMerge[i].rowArr.push(1);
                                needMerge[i].rowMergeNum = index;
                            }
                        }
                    });
                } else {
                    let firstRowArr = needMerge[arr[0]].rowArr;
                    let firstRowArrDeal = [];
                    firstRowArr.forEach((item, index) => {
                        if (item > 0) {
                            firstRowArrDeal.push(index);
                        }
                    });
                    data.forEach((item, index) => {
                        let sign = false;
                        if (firstRowArrDeal.indexOf(index) > 0) {
                            needMerge[i].rowMergeNum = index;
                            sign = true;
                        }
                        // 表格首个数据单独处理
                        if (index === 0) {
                            needMerge[i].rowArr.push(1);
                            needMerge[i].rowMergeNum = 0;
                        } else {
                            if (item[i] === data[index - 1][i]) {
                                if (sign) {
                                    needMerge[i].rowArr.push(1);
                                } else {
                                    if (item[arr[idx - 1]] != data[index - 1][arr[idx - 1]]) {
                                        needMerge[i].rowArr.push(1);
                                        needMerge[i].rowMergeNum = index;
                                    } else {
                                        needMerge[i].rowArr[needMerge[i].rowMergeNum] += 1;
                                        needMerge[i].rowArr.push(0);
                                    }
                                }
                            } else {
                                needMerge[i].rowArr.push(1);
                                needMerge[i].rowMergeNum = index;
                            }
                        }
                    });
                }
            });
            return needMerge;
        },

    }
};
</script>
  